/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestConvexCvxLocker extends Contract<ITestConvexCvxLocker> {
  balanceOf: Call<(_user: AddressLike) => BigNumber, ITestConvexCvxLocker>
  'balanceOf(address)': Call<(_user: AddressLike) => BigNumber, ITestConvexCvxLocker>
  checkpointEpoch: Send<() => void, ITestConvexCvxLocker>
  'checkpointEpoch()': Send<() => void, ITestConvexCvxLocker>
  getReward: Send<(_account: AddressLike, _stake: boolean) => void, ITestConvexCvxLocker>
  'getReward(address,bool)': Send<(_account: AddressLike, _stake: boolean) => void, ITestConvexCvxLocker>
  lockedBalanceOf: Call<(_user: AddressLike) => BigNumber, ITestConvexCvxLocker>
  'lockedBalanceOf(address)': Call<(_user: AddressLike) => BigNumber, ITestConvexCvxLocker>
}

let ITestConvexCvxLockerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestConvexCvxLockerBytecode = '0x';
}

// prettier-ignore
export const ITestConvexCvxLocker = contract<ITestConvexCvxLocker>(ITestConvexCvxLockerBytecode)`
  function balanceOf(address _user) view returns (uint256 amount_)
  function checkpointEpoch()
  function getReward(address _account, bool _stake)
  function lockedBalanceOf(address _user) view returns (uint256 amount_)
`;